// 错误代码常量
export const VideoRecorderErrorCodes = {
    PERMISSION_DENIED: 'PERMISSION_DENIED',
    RECORDING_FAILED: 'RECORDING_FAILED',
    INVALID_OPTIONS: 'INVALID_OPTIONS',
    ALREADY_RECORDING: 'ALREADY_RECORDING',
    NOT_RECORDING: 'NOT_RECORDING',
    FILE_NOT_FOUND: 'FILE_NOT_FOUND',
    STORAGE_ERROR: 'STORAGE_ERROR',
    CAMERA_ERROR: 'CAMERA_ERROR',
    MICROPHONE_ERROR: 'MICROPHONE_ERROR',
    CAPTURE_CANCELLED: 'CAPTURE_CANCELLED',
};
